import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workRequestId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workRequestId`;

export const URL = (workRequestId: number): RouteDefinition => `${baseRoute}/${workRequestId}`;
